import { render } from "./Settings.vue?vue&type=template&id=6b98e16e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6b98e16e"

export default script